<template>
  <div class="pratice-explanatory-topics-content" id="identidade-verbal-na-pratica-temas-explicativos-produto-ou-cultura" data-search-anchor>
      <h1 class="pratice-explanatory-topics-title">
          {{ praticeExplanatoryTopicsTitle }}
        </h1>               

        <div class="pratice-explanatory-topics-wrapper">
            <div class="pratice-explanatory-topics-release-container">
                <p class="pratice-release-paragraph-title">{{ praticeReleaseParagraphTitle }}</p>
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph1 }}</p>                        
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph2 }}</p>                
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph3 }}</p>
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph4 }}</p>
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph5 }}</p>                         
            </div>

            <div class="pratice-explanatory-topics-tips-container">
                <p class="pratice-explanatory-topics-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-explanatory-topics-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <OneCircle />
                <p class="pratice-tips-explanatory-topics-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <OneCircle />
                <p class="pratice-tips-explanatory-topics-paragraph">{{ praticeTipsParagraph5 }}</p>
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph6 }}</p>
                <ThreeCircles />

                <div class="pratice-legend-explanatory-topics-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph7 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph8 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeExplanatoryTopicsSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeExplanatoryTopicsTitle(): string {
    return this.getElementTitle(6, 0)
  }

  get praticeReleaseParagraphTitle(): string {
    return this.getElementText(6, 0)
  }

  get praticeReleaseParagraph1(): string {
    return this.getElementText(6, 1)
  }

  get praticeReleaseParagraph2(): string {
    return this.getElementText(6, 2)
  }

  get praticeReleaseParagraph3(): string {
    return this.getElementText(6, 3)
  }

  get praticeReleaseParagraph4(): string {
    return this.getElementText(6, 4)
  }

  get praticeReleaseParagraph5(): string {
    return this.getElementText(6, 5)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(6, 6)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(6, 7)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(6, 8)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(6, 9)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(6, 10)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(6, 11)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(6, 12)
  }

  get praticeTipsParagraph7(): string {
    return this.getElementText(6, 13)
  }

  get praticeTipsParagraph8(): string {
    return this.getElementText(6, 14)
  }

  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-explanatory-topics-content {
  display: grid;
  justify-content: center;
  margin-top: 80px;  
  max-width: 1032px;
}

.pratice-explanatory-topics-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  text-align: left;
  margin: 0;
  width: 100%;
}

.pratice-explanatory-topics-wrapper {
  position: relative; 
  display: grid;
  grid-template-columns: repeat(2, 495px);
  column-gap: 42px;
  margin-top: 50px;
}

.pratice-explanatory-topics-release-container {
  width: 506px;
  height: 1120px;
  border-radius: 16px; 
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
  white-space: pre;
}

.pratice-explanatory-topics-tips-container {
  width: 506px;
  height: 1120px;    
}

.pratice-release-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-release-paragraph:last-of-type{
  white-space: pre;
}

.pratice-release-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
}

.pratice-release-paragraph-title {
  white-space: pre;
}

.pratice-explanatory-topics-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 127px;
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-explanatory-topics-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-explanatory-topics-paragraph:nth-child(5) {
  margin-top: 146px;
}

.pratice-tips-explanatory-topics-paragraph:nth-child(8) {
  margin-top: 128px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  font-size: 16px;  
  line-height: 24px;
  margin: 0;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-explanatory-topics-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 127px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
